function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-check-green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Pledge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.93,1.84,6,12.29a.2.2,0,0,1-.31,0L.07,6.36A.24.24,0,0,1,.07,6L1.43,4.59a.21.21,0,0,1,.32,0L5.86,8.91,14.25.07a.22.22,0,0,1,.32,0l1.36,1.44A.24.24,0,0,1,15.93,1.84Z",
    transform: "translate(0)",
    style: {
      fill: "#FFF"
    }
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckWhite);
export default __webpack_public_path__ + "static/media/icon-check-white.d5496ead707509b3e0e8fa9804b82aff.svg";
export { ForwardRef as ReactComponent };